import { getLang } from '../i18n/LanguageContext';

import { parseDbDate, isDateOnly } from './kernelFormat';
import { zonedParts } from './kernelTimezone';

export { fmtNum, fmtPct, fmtEuro, fmtDate, fmtDateTime } from './kernelFormat';

// Giorno, mese e anno di un valore: una data semplice è quella scritta, un istante del database (UTC) si legge nel fuso in uso.
const calendarParts = (value) => {
  const d = parseDbDate(value);
  if (isNaN(d)) return null;
  if (isDateOnly(value)) return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  const p = zonedParts(d);
  return { year: p.year, month: p.month, day: p.day };
};

// Formato fisso DD-MM-YYYY (a differenza di fmtDate, che segue il formato
// nativo del browser/locale, es. DD/MM/YYYY) - richiesto per la colonna
// "Creato il" della lista ticket.
export const fmtDateDMY = (value) => {
  if (!value) return '—';
  const p = calendarParts(value);
  if (!p) return String(value);
  return `${String(p.day).padStart(2, '0')}-${String(p.month).padStart(2, '0')}-${p.year}`;
};

const MONTHS_IT = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Data relativa (Oggi/Ieri/Domani, altrimenti "16 set") - solo la data, senza
// orario: usata per la scadenza dei ticket, che nel nostro form è solo un
// giorno (niente ora), quindi mostrare "00:00" sarebbe fuorviante.
export const fmtRelativeDate = (value) => {
  if (!value) return '—';
  const p = calendarParts(value);
  if (!p) return String(value);
  const t = zonedParts(new Date());
  const diffDays = Math.round((Date.UTC(p.year, p.month - 1, p.day) - Date.UTC(t.year, t.month - 1, t.day)) / 86400000);
  const en = getLang().startsWith('en');
  if (diffDays === 0) return en ? 'Today' : 'Oggi';
  if (diffDays === -1) return en ? 'Yesterday' : 'Ieri';
  if (diffDays === 1) return en ? 'Tomorrow' : 'Domani';
  const months = en ? MONTHS_EN : MONTHS_IT;
  return `${p.day} ${months[p.month - 1]}`;
};
